import React, { createContext, useState, useContext, useEffect, useRef } from 'react';
import { useLanguage } from '../Language/LanguageContext';
import { fetchData } from '../AxiosRequest/axios';

const NavbarContext = createContext();

export const NavbarProvider = ({ children }) => {
    const [navbarData, setNavbarData] = useState(() => {
        const saved = localStorage.getItem('navbarCache');
        return saved ? JSON.parse(saved) : [];
    });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const { language } = useLanguage();
    const effectRan = useRef(false);

    const loadNavbar = async () => {
        const cacheKey = `navbar-${language}`;
        const cached = localStorage.getItem(cacheKey);

        if (cached) {
            setNavbarData(JSON.parse(cached));
            return;
        }

        setIsLoading(true);
        setError(null);
        try {
            const data = await fetchData({
                endpoint: 'menu',
                lang: language,
            });
            if (data && data.length > 0) {
                const menuData = Object.values(data[0]);
                setNavbarData(menuData);
                localStorage.setItem(cacheKey, JSON.stringify(menuData));
            } else {
                throw new Error('Invalid menu data structure');
            }
        } catch (err) {
            console.error('Navbar fetch error:', err);
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (!language || effectRan.current) return;
        loadNavbar();
        effectRan.current = true;
    }, [language]);

    return (
        <NavbarContext.Provider value={{ navbarData, setNavbarData, isLoading, error }}>
            {children}
        </NavbarContext.Provider>
    );
};

export const useNavbar = () => {
    const context = useContext(NavbarContext);
    if (context === undefined) {
        throw new Error('useNavbar must be used within a NavbarProvider');
    }
    return context;
};
